module.exports = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};


//# sourceMappingURL=lv-LV.main.js.map
